import ResultCard from "./ResultCard";

const ResultList = ({ results }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {results.map((res) => (
        <ResultCard key={res._id} result={res} />
      ))}
    </div>
  );
};

export default ResultList;
